"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsRoutingTransitionSpeed_1 = __importDefault(require("../../typeAssertions/valueIsRoutingTransitionSpeed"));
const executeTransition_1 = __importDefault(require("../../shared/executeTransition"));
const valueIsBoolean_1 = __importDefault(require("../../typeAssertions/valueIsBoolean"));
const callableToggleBottomMenu = ({ entryVars: { animationSpeed, close, }, callbacks, executeProcesses, processor, }) => {
    try {
        const shouldOpened = !((0, valueIsBoolean_1.default)(close) && close);
        const alreadyOpened = !!processor.root.isBottomMenuOpened;
        const onOpen = () => {
            processor.root.setIsBottomMenuOpened(true);
            processor.root.isBottomMenuOpened = true; // eslint-disable-line
            if ((0, valueIsRoutingTransitionSpeed_1.default)(animationSpeed)) {
                processor.root.setTransitionBottomMenu({
                    type: 'SlideTop',
                    speed: animationSpeed,
                });
                (0, executeTransition_1.default)(animationSpeed).then(() => {
                    processor.root.setTransitionBottomMenu(undefined);
                });
            }
        };
        const onClose = () => {
            if ((0, valueIsRoutingTransitionSpeed_1.default)(animationSpeed)) {
                processor.root.setTransitionBottomMenu({
                    type: 'SlideTopOut',
                    speed: animationSpeed,
                });
                (0, executeTransition_1.default)(animationSpeed).then(() => {
                    processor.root.setIsBottomMenuOpened(false);
                    processor.root.setTransitionBottomMenu(undefined);
                    processor.root.isBottomMenuOpened = false; // eslint-disable-line
                });
                return;
            }
            processor.root.setIsBottomMenuOpened(false);
            processor.root.isBottomMenuOpened = false; // eslint-disable-line
        };
        if (shouldOpened && !alreadyOpened) {
            onOpen();
        }
        else if (!shouldOpened && alreadyOpened) {
            onClose();
        }
        executeProcesses(undefined, callbacks.successProcess);
    }
    catch (_a) {
        executeProcesses(undefined, callbacks.errorProcess);
    }
};
exports.default = callableToggleBottomMenu;
